export enum UnitConfigurations {
  HideTrendingResearchTopics = 'HideTrendingResearchTopics',
  HideResearchAtAGlance = 'HideResearchAtAGlance',
  OverriddenAboutBandHeading = 'OverriddenAboutBandHeading',
  OverriddenAboutBandText = 'OverriddenAboutBandText',
  OverriddenUnitResearchAtAGlanceTypes = 'OverriddenUnitResearchAtAGlanceTypes',
}
